import "./EventsButton.css"
import { NavLink } from 'react-router-dom';

export default function EventsButton() {
    return (
        <NavLink to="/events">
            <button className="event-button">
                Wszystkie wydarzenia
            </button>
        </NavLink>

    )
}